<template>
  <div class="modal-card" style="width: auto">
    <section class="modal-card-body has-text-centered" id="cashback">
      <h2 class="subtitle">
        <span class="money-icon">💵</span>
        {{ $t("dashboard.cashback") }}
      </h2>
      <br />

      <p
        v-if="
          orderedCashbacks.length === 1 &&
            orderedCashbacks[0].type === 'general'
        "
      >
        <b>
          {{
            `${cashbacks[0].percentage}% ${$t(
              "settings.cashbackInEveryProduct"
            )}`
          }}
        </b>
        <br />
        <small>
          {{
            `${moment
              .utc(cashbacks[0].beginDate)
              .add(preferences.timezone, "h")
              .format("DD/MM/YY HH:mm")} à ${moment
              .utc(cashbacks[0].endDate)
              .add(preferences.timezone, "h")
              .format("DD/MM/YY HH:mm")}`
          }}
        </small>
      </p>

      <div v-else>
        <p v-for="c in orderedCashbacks" :key="c._id" class="cashback-item">
          <span v-if="c.type === 'product'">
            <b>
              {{
                `${c.percentage}% ${$t("settings.cashbackInProduct")} ${
                  c.product.name
                } (${$t("settings.cashbackBarcode")} ${c.product.barcode})`
              }}
            </b>
            <br />
            <small>
              {{
                `${moment
                  .utc(cashbacks[0].beginDate)
                  .add(preferences.timezone, "h")
                  .format("DD/MM/YY HH:mm")} à ${moment
                  .utc(cashbacks[0].endDate)
                  .add(preferences.timezone, "h")
                  .format("DD/MM/YY HH:mm")}`
              }}
            </small>
          </span>

          <span v-else-if="c.type === 'subcategory'">
            <b>
              {{
                `${c.percentage}% ${$t("settings.cashbackInSubcategory")} ${
                  c.subcategory.name
                }`
              }}
            </b>
            <br />
            <small>
              {{
                `${moment
                  .utc(cashbacks[0].beginDate)
                  .add(preferences.timezone, "h")
                  .format("DD/MM/YY HH:mm")} à ${moment
                  .utc(cashbacks[0].endDate)
                  .add(preferences.timezone, "h")
                  .format("DD/MM/YY HH:mm")}`
              }}
            </small>
          </span>

          <span v-else-if="c.type === 'category'">
            <b>
              {{
                `${c.percentage}% ${$t("settings.cashbackInCategory")} ${
                  c.category.name
                }`
              }}
            </b>
            <br />
            <small>
              {{
                `${moment
                  .utc(cashbacks[0].beginDate)
                  .add(preferences.timezone, "h")
                  .format("DD/MM/YY HH:mm")} à ${moment
                  .utc(cashbacks[0].endDate)
                  .add(preferences.timezone, "h")
                  .format("DD/MM/YY HH:mm")}`
              }}
            </small>
          </span>

          <span v-else-if="c.type === 'general'">
            <b>
              {{ `${c.percentage}% ${$t("settings.cashbackInOtherProducts")}` }}
            </b>
            <br />
            <small>
              {{
                `${moment
                  .utc(cashbacks[0].beginDate)
                  .add(preferences.timezone, "h")
                  .format("DD/MM/YY HH:mm")} à ${moment
                  .utc(cashbacks[0].endDate)
                  .add(preferences.timezone, "h")
                  .format("DD/MM/YY HH:mm")}`
              }}
            </small>
          </span>
        </p>
      </div>
      <br />
      <br />

      <cashback-rules />
      <br />
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import cashbackRules from "./CashbackRules";

export default {
  props: ["cashbacks"],

  components: {
    cashbackRules
  },

  computed: {
    ...mapGetters(["preferences"]),

    orderedCashbacks() {
      const product = this.cashbacks.filter(c => {
        return c.type === "product";
      });
      const subcategory = this.cashbacks.filter(c => {
        return c.type === "subcategory";
      });
      const category = this.cashbacks.filter(c => {
        return c.type === "category";
      });
      const general = this.cashbacks.filter(c => {
        return c.type === "general";
      });
      return product
        .concat(subcategory)
        .concat(category)
        .concat(general);
    }
  }
};
</script>

<style scoped>
#cashback {
  padding-left: 1rem;
  padding-right: 1rem;
}
.money-icon {
  position: relative;
  top: 1px;
}
.cashback-item {
  margin-top: 0.75rem;
}
</style>
